import { render, staticRenderFns } from "./AppAnnotationAssessmentRoot.vue?vue&type=template&id=cf207058&scoped=true"
import script from "./AppAnnotationAssessmentRoot.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationAssessmentRoot.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationAssessmentRoot.vue?vue&type=style&index=0&id=cf207058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf207058",
  null
  
)

export default component.exports